const CHARGE_STATUS_LABELS = {
  draft: 'Draft',
  // We do not want to confuse merchants with the concept of an expired draft, so we just name them drafts.
  draft_expired: 'Draft',
  created: 'Created',
  pending: 'Pending',
  unpaid: 'Unpaid',
  partially_paid: 'Partially paid',
  paid: 'Paid',
  canceled: 'Canceled',
  failed: 'Failed',
  refunded: 'Refunded',
  partial_refund: 'Partial refund',
};

export default function getChargeStatusLabel(status) {
  return CHARGE_STATUS_LABELS[status] || 'Unknown';
}
